import Popin from './../components/popin'

export default homePage => {
    homePage.querySelector('.js-btn-manisfesto').addEventListener('click', (e) => {
        e.preventDefault();
        new Popin({id: 'popin-manifesto'});
    });

    const stage = homePage.querySelector('.homepage__stage');
    let bgImg = (window.innerWidth > 768) ? stage.getAttribute('data-image-desktop') : stage.getAttribute('data-image-mobile');
    stage.style.backgroundImage = `url(${bgImg})`;
};
